import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "IconProps"];
import React from 'react';
import ArrowBottom from '@scaleflex/icons/arrow-bottom';
import { intrinsicComponent } from '../../utils/functions';
import { Position } from '../../utils/types';
import Styled from './arrow-tick.styles';
var ArrowTick = intrinsicComponent(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? Position.Right : _ref$type,
    IconPropsData = _ref.IconProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.ArrowTick, _extends({}, rest, {
    type: type,
    ref: ref
  }), /*#__PURE__*/React.createElement(ArrowBottom, IconPropsData));
});
export default ArrowTick;